import { useEffect } from 'react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import SecuredPage from 'Views/Components/Security/SecuredPage';
import { RegisterCustomer } from 'Views/Components/_HumanWritten/RegisterCustomer/RegisterCustomer';
import { SecuredGroups } from 'Models/Security/UserGroups';
import { REGISTRATION_PAGE_TITLE } from 'ConstantPageNames';
import { themeStore } from 'Models/ThemeStore';
import useDeviceDetect from 'Hooks/useDeviceDetect';

export default function RegisterCustomerPage() {
	const { isMobile } = useDeviceDetect();

	useEffect(() => {
		document.title = REGISTRATION_PAGE_TITLE;
	}, []);

	return (
		<SecuredPage groups={SecuredGroups.create.onlyStaff().groups}>
			<div className="login-page">
				<Link className="logo-link" to="/home">
					<img
						src={isMobile ? themeStore.logoSecondaryLightURL : themeStore.logoPrimaryLightURL}
						alt="Company Logo"
					/>
				</Link>
				<div
					className="top-section"
					style={{
						backgroundImage: `url(${themeStore.loginBackgroundImageURL})`,
						backgroundSize: 'cover',
						backgroundPosition: 'center',
					}}
				/>
				<div className="bottom-section" />
				<div className="center-section">
					<RegisterCustomer />
				</div>
			</div>
		</SecuredPage>
	);
}
